import React, { useState, useEffect } from 'react';

import GenericInputContainer from '../shared/GenericInputContainer';
import DisplayDate from './DisplayDate';
import EditDate from './EditDate';

const DateInputContainer = ({ initialValue: onPageLoadValue, syncChanges, isEditing, setIsEditing, isHovered }) => {
    const [value, setValue] = useState(onPageLoadValue ? onPageLoadValue : '');
    const [initialValue, setInitialValue] = useState(onPageLoadValue ? onPageLoadValue : '');
    const [invalidMsg, setInvalidMsg] = useState('');
    const dateFormat = 'YYYY-MM-DD';

    useEffect(() => {
        setValue(onPageLoadValue ? onPageLoadValue : '');
        setInitialValue(onPageLoadValue ? onPageLoadValue : '');
    }, [onPageLoadValue]);

    const isFieldNull = !value || !value.length;

    const valueHasntChanged = () => {
        return value === initialValue;
    };

    const handleSave = async () => {
        const syncValue = value === '' ? null : value;
        const response = await syncChanges(syncValue);
        if (response.success) {
            setInitialValue(value);
        }
        return response;
    };

    const handleCancel = () => {
        setValue(initialValue);
        setInvalidMsg('');
    };

    return (
        <GenericInputContainer {...{ isEditing, setIsEditing, isHovered, isFieldNull, handleSave, handleCancel, valueHasntChanged }}>
            <DisplayDate {...{ value, dateFormat }} />
            <EditDate {...{ value, setValue, invalidMsg, dateFormat }} />
        </GenericInputContainer>
    );
};

export default DateInputContainer;
